module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.674f50d287a8c48dc19ba404d20fe713.eot";